import { Injectable } from '@angular/core';

import { EventDetailsColumnType, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({
    providedIn: 'root',
})
export class MediaTrackingService {
    private mediaTabs = {
        [EventDetailsColumnType.Stats]: 'stats tab',
        [EventDetailsColumnType.Animation]: 'animation tab',
        [EventDetailsColumnType.Video]: 'video tab',
    };

    constructor(private trackingService: TrackingService) {}

    trackTabClick(eventActiveId: EventDetailsColumnType, event: EventModel | null, index: number): void {
        if (!event) {
            return;
        }

        const trackingData = {
            ...this.baseTracking,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: this.mediaTabs[eventActiveId] ?? NOT_APPLICABLE,
            [trackingConstants.SPORT_ID]: event.sport.id.toString(),
            [trackingConstants.SPORT_EVENT_ID]: event.id.toString(),
            [trackingConstants.COMPONENT_CONTENT_POSITION]: index.toString(),
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackPanelToggle(isCollapsed: boolean): void {
        const trackingData = {
            ...this.baseTracking,
            [trackingConstants.COMPONENT_ACTION_EVENT]: isCollapsed ? 'Expand' : 'Collapse',
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackPin(isPinned: boolean): void {
        const trackingData = {
            ...this.baseTracking,
            [trackingConstants.COMPONENT_ACTION_EVENT]: isPinned ? 'unpin' : 'pin',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'video',
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    private get baseTracking(): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Media Module',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'Media Module Interactions',
            [trackingConstants.COMPONENT_ACTION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
    }
}
